export default __webpack_public_path__ + "static/media/face-detection-and-recognition.e53986c4.png";